import React, { useMemo } from 'react';

import { DishPicture } from '../DishPicture';
import { DishDetailsPicture } from '../../DishDetails/DishDetailsImage';

import { MediaContentContext, OnClickOpenDetails } from './dishMediaContent.types';

import s from './dish-media-content.module.scss';


type DishPictureSlideProps = {
    context: MediaContentContext,
    alt?: string,
    imageUrl: string,
    imageUrlDesktop: string,
    onClickOpenDetails: OnClickOpenDetails,
}


export function DishPictureSlide({
    context,
    alt = '',
    imageUrl,
    imageUrlDesktop,
    onClickOpenDetails,
}: DishPictureSlideProps) {
    const PictureComponent = useMemo(() => {
        if (context === 'details') return DishDetailsPicture;
        return DishPicture;
    }, [context]);

    return (
        <>
            <PictureComponent
                useLazyLoading={false}
                alt={alt}
                imageUrl={imageUrl}
                imageUrlDesktop={imageUrlDesktop}
            />
            {context === 'card' && (
                <button
                    type="button"
                    className={s.openDetailsButton}
                    onClick={onClickOpenDetails}
                >
                    open details
                </button>
            )}
        </>
    );
}
